// These URLs are cross-origin storage links that browsers won't allow page
// JS to read the bytes of without server-side CORS support, so real in-page
// progress tracking isn't possible here. A plain navigation download lets
// the browser handle the transfer (and its own download UI) directly,
// avoiding a wasted duplicate fetch that a blocked fetch/axios attempt would
// otherwise trigger.
export const startDownload = (url: string) => {
  const link = document.createElement('a')
  link.href = url
  link.download = ''
  link.click()
}
